import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";

const productId = 4;
const serviceId = '10769';
const channel = 'WAP';
const doiChannel = 'USSD_NI'
const billingRate = 200;

export default class DepService {
    static async decryptMsisdn(encryptedMsisdn) {
        return await axios.post(`${environmentConfig.depService}/decrypt-msisdn/v2`, {
                encryptedMsisdn,
            },
        )
    }

    static async encryptMsisdn(msisdn) {
        return await axios.post(`${environmentConfig.depService}/encrypt-msisdn/v2`, {
            msisdn,
            },
        )
    }

    static async getUserViaProductId(msisdn) {
        try {
            return await axios.post(`${environmentConfig.depService}/get-user-via-msisdn`, {
                    msisdn,
                    productId: productId,
                },
            )
        } catch (e) {
            return {authError: true};
        }
    }

    static async adHocBillingRequest(msisdn) {
        return await axios.post(`${environmentConfig.depService}/ad-hoc-billing-request`, {
                msisdn: msisdn,
                serviceId,
                externalRef: 123456789,
                channel,
                doiChannel,
                billingRate
            },
        )
    }
}